const phonenumber = {
	name: 'Telefonnummer | Telefonnummern',
	icon: 'fa-solid fa-phone',
	fields: {
		number: 'Nummer',
		communication_type: 'Kommunikationsart',
		description: '@:common.description',
		notice: 'Notiz',
		typeNotFound: 'Typ nicht gefunden',
	},
}

export default phonenumber
